


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public myPlayer: any = null;
  @Prop({
    type: String,
    default: "",
  })
  public url;
  @Prop({ type: Boolean, default: false })
  public show;

  public percent = 0;
  public percentTimer: any = null;
  public isPause = false; // 是否暂停中
  public isFullscreen = false;
  public sTime = "00:00";
  public eTime = "";
  public boxid = "";
  public pid = "";
  public isMuted = false;
  public recordPercent = 50;
  public viocePercent = 50;
  public timer: any = null;
  public screen = 1000;
  public isHover = false; // 是否鼠标在区域内
  public isloading = true;

  @Watch("show")
  public showChange() {
    if (this.show) {
      this.isloading = true;
      const $charsA = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz";
      const maxPosA = $charsA.length;
      for (let i = 0; i < 6; i++) {
        this.boxid += $charsA.charAt(Math.floor(Math.random() * maxPosA));
      }
      const $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz";
      const maxPos = $chars.length;
      for (let i = 0; i < 6; i++) {
        this.pid += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      setTimeout(() => {
        this.initVideo();
      }, 100);
    } else {
      this.sTime = "00:00";
      this.viocePercent = 0;
      this.isloading = true;
      this.myPlayer.dispose();
    }
  }
  @Watch("viocePercent")
  public vioceChange() {
    const num = this.viocePercent / 100;
    this.myPlayer.volume(num);
  }

  public mounted() {
    // this.initVideo();
    // console.log(1);
    // Esc按键退出全屏
  }

  public initVideo() {
    const myVideoDiv: any = document.getElementById(this.boxid);
    const dom = `<div class="video-prism-player" id="${this.pid}" ref="${this.pid}"></div>`;
    myVideoDiv.innerHTML = dom;
    this.$nextTick(() => {
      const urlObj = {
        FD: this.url,
        SD: this.url,
        HD: this.url,
      };
      this.myPlayer = new (window as any).Aliplayer(
        {
          id: this.pid,
          width: "100%",
          height: "100%",
          autoplay: true,
          // 支持播放地址播放,此播放优先级最高
          source: JSON.stringify(urlObj),
          isLive: false,
          skinLayout: [
            { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
            {
              name: "H5Loading",
              align: "cc",
            },
            { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
            { name: "infoDisplay" },
            { name: "tooltip", align: "blabs", x: 0, y: 56 },
            { name: "thumbnail" },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                { name: "progress", align: "blabs", x: 0, y: 44 },
                { name: "playButton", align: "tl", x: 12, y: 46 },
                { name: "timeDisplay", align: "tl", x: 10, y: 42 },
                { name: "fullScreenButton", align: "tr", x: 10, y: 46 },
                { name: "volume", align: "tr", x: 5, y: 46 },
              ],
            },
          ],
          // hlsFrameChasing: true,
          // 播放方式二：推荐点播用户使用
          // vid: "1e067a2831b641db90d570b6480fbc40",
          // playauth: "ddd",
          // cover: "http://liveroom-img.oss-cn-qingdao.aliyuncs.com/logo.png",
          // encryptType: 1, //当播放私有加密流时需要设置。
        },
        (player: any) => {
          // console.log("播放器创建好了。");
          // player.pause();
          player.on("error", (e) => {
            // 隐藏
            //   $(".prism-ErrorMessage").hide();
            // 解析
            const errorData = e.paramData;
            //   console.dir(errorData);
          });
        }
      );
    });
  }
}
